// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#HtmlReader {
  text-wrap: auto;
}
#HtmlReader h1,
#HtmlReader h2,
#HtmlReader h3,
#HtmlReader h4,
#HtmlReader h5,
#HtmlReader h6 {
  line-height: 1;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
#HtmlReader p {
  margin-bottom: 0.6rem;
  line-height: 1.2rem;
}
#HtmlReader ul li p, #HtmlReader ol li p {
  margin-bottom: 0.2rem;
}
#HtmlReader p.is-editor-empty:first-child::before {
  color: #9ea0b9;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/html-reader/HtmlReader.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACI;;;;;;EAMI,cAAA;EACA,kBAAA;EACA,qBAAA;AACR;AAEI;EACI,qBAAA;EACA,mBAAA;AAAR;AAKY;EACI,qBAAA;AAHhB;AAQI;EACI,cAAA;EACA,+BAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;AANR","sourcesContent":["#HtmlReader {\n    text-wrap: auto;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        line-height: 1;\n        margin-top: 1.5rem;\n        margin-bottom: .5rem;\n    }\n\n    p{\n        margin-bottom: .6rem;\n        line-height: 1.2rem;\n    }\n\n    ul,ol{\n        li{\n            p{\n                margin-bottom: .2rem;\n            }\n        }\n    }\n\n    p.is-editor-empty:first-child::before {\n        color: #9ea0b9;\n        content: attr(data-placeholder);\n        float: left;\n        height: 0;\n        pointer-events: none;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
